export const TAB_TITLE_PREFIX_RE = /^\(\d+\+?\)\s*/;

export function stripTabTitlePrefix(title) {
  return title.replace(TAB_TITLE_PREFIX_RE, "");
}

export function formatTabTitle(unreadCount, currentTitle) {
  const base = stripTabTitlePrefix(currentTitle);
  if (unreadCount <= 0) return base;
  const badge = unreadCount > 99 ? "99+" : String(unreadCount);
  return `(${badge}) ${base}`;
}
